import { render, staticRenderFns } from "./TransactionDetail.vue?vue&type=template&id=73df253c"
import script from "./TransactionDetail.vue?vue&type=script&lang=js"
export * from "./TransactionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports